export default {
  rtl  : false,
  theme: {
    disable: false,
    dark   : false,
    options: {},
    themes : {
      dark: {
        'anchor'   : '#252E27',
        'primary'  : '#252E27',
        'secondary': '#424242',
        'accent'   : '#82B1FF',
        'error'    : '#FF5252',
        'info'     : '#2196F3',
        'success'  : '#9AAA90',
        'warning'  : '#FB8C00',

        'brand-primary'  : '#9AAA90',
        'brand-secondary': '#E5E0CD',
        'brand-card-bg'  : '#F8F7F2',

        'brand-green'      : '#9AAA90',
        'brand-green-dark' : '#252E27',
        'brand-green-light': '#BFCAB9',
        'brand-beige'      : '#F1EEE4',
        'brand-beige-dark' : '#E5E0CD',
        'brand-beige-light': '#F8F7F2',
        'brand-grey'       : '#979797'
      },

      light: {
        'anchor'   : '#252E27',
        'primary'  : '#252E27',
        'secondary': '#424242',
        'accent'   : '#82B1FF',
        'error'    : '#FF5252',
        'info'     : '#2196F3',
        'success'  : '#9AAA90',
        'warning'  : '#FB8C00',

        'brand-primary'  : '#9AAA90',
        'brand-secondary': '#E5E0CD',
        'brand-card-bg'  : '#F8F7F2',

        'brand-green'      : '#9AAA90',
        'brand-green-dark' : '#252E27',
        'brand-green-light': '#BFCAB9',
        'brand-beige'      : '#F1EEE4',
        'brand-beige-dark' : '#E5E0CD',
        'brand-beige-light': '#F8F7F2',
        'brand-grey'       : '#979797'
      }
    }
  },
  icons     : {},
  breakpoint: {}
}
